import type { BuilderAddon, BuilderStiffnessOption } from '@/types'

/**
 * Function step defaults — the ride-feel stiffness ladder (single choice) and
 * the frame add-ons (multi choice). Both lists are fully CMS-editable in the
 * Builder workbench; these are only the seeded starting points. None of these
 * choices affect the builder's visual preview — they are spec/price only.
 */

/** Stiffness / ride-feel — the rider picks exactly one. */
export const DEFAULT_STIFFNESS_OPTIONS: BuilderStiffnessOption[] = [
  {
    id: 'stiffness-compliant',
    label: 'Compliant',
    description:
      'The most forgiving layup schedule. Extra vertical give takes the sting out of long, chattery descents and all-day terrain.',
    imageUrl: '',
    price: 0,
    enabled: true,
  },
  {
    id: 'stiffness-balanced',
    label: 'Balanced',
    description:
      'The house tune. Measured compliance that settles the bike into rough ground without dulling the response — our default for most riders.',
    imageUrl: '',
    price: 0,
    enabled: true,
  },
  {
    id: 'stiffness-rigid',
    label: 'Rigid',
    description:
      'The stiffest schedule. Direct power transfer and sharp, immediate steering for race pace and hard, precise efforts.',
    imageUrl: '',
    price: 0,
    enabled: true,
  },
]

/** Frame add-ons — the rider picks any number. Each adds to the build total. */
export const DEFAULT_ADDONS: BuilderAddon[] = [
  {
    id: 'addon-geometry-chips',
    label: 'Geometry Adjust Chips',
    description:
      'Two-position eccentric chips at the shock mount, shifting head angle and BB height between a slacker and a steeper setting.',
    imageUrl: '',
    price: 180,
    enabled: true,
  },
  {
    id: 'addon-angle-headset',
    label: 'Angle-Adjust Headset Cups',
    description:
      'Offset upper and lower cups that steepen or slacken the head angle by up to a degree, tuned to your terrain at fitting.',
    imageUrl: '',
    price: 220,
    enabled: true,
  },
  {
    id: 'addon-chainstay-chips',
    label: 'Chainstay Length Chips',
    description:
      'Swappable dropout chips that shift rear-centre — shorter for a playful balance, longer for planted high-speed stability.',
    imageUrl: '',
    price: 160,
    enabled: true,
  },
  {
    id: 'addon-internal-storage',
    label: 'Internal Frame Storage',
    description:
      'A sealed down-tube compartment with a machined hatch — tools, tube, and essentials carried inside the frame.',
    imageUrl: '',
    price: 260,
    enabled: true,
  },
  {
    id: 'addon-brake-arm',
    label: 'Brake Booster Arm',
    description:
      'A bolt-on brace tying the calliper mount to the frame, reducing flex under heavy braking on the hardest descents.',
    imageUrl: '',
    price: 190,
    enabled: true,
  },
]
